import { DocumentSnapshot, SnapshotOptions } from 'firebase/firestore';

export type SnapDataOptions = SnapshotOptions & {
	idField?: string;
};

export function snapToData<T>(
	snapshot: DocumentSnapshot<T>,
	options: SnapDataOptions = {},
): T | undefined {
	const data = snapshot.data(options);

	if (
		!snapshot.exists() ||
		typeof data !== 'object' ||
		data === null ||
		!options.idField
	) {
		return data;
	}

	return { ...data, [options.idField]: snapshot.id } as T;
}
